import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { registerManagers } from "../../../reducers/authentication.slice";
import { AuthContext } from "../../../context/authContext";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";

const PERMISSIONS = [
  { name: "dashboard", label: "Dashboard" },
  { name: "shipping_and_tracking", label: "Shipping and Tracking" },
  { name: "live_orders", label: "Live Orders" },
  { name: "completed_orders", label: "Completed Orders" },
  { name: "pending_rsc_quotes", label: "Pending RSC Quotes" },
  { name: "pre_quoted_cooks", label: "Sell Catalog" },
  { name: "in_store_flips", label: "In-Store Flips" },
  { name: "user_management", label: "User Management" },
  { name: "analytics", label: "Analytics" },
  { name: "terms_and_conditions", label: "Terms and Conditions" },
];

const UserRegisterationForm = ({ dialogMode = false, onSuccess }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = useContext(AuthContext);
  const [showLoader, setShowLoader] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    role: "MANAGER",
    discord_id: "",
    email: "",
    permission_details: {
      access_level: "WRITE",
      dashboard: false,
      shipping_and_tracking: false,
      live_orders: false,
      completed_orders: false,
      pending_rsc_quotes: false,
      pre_quoted_cooks: false,
      in_store_flips: false,
      user_management: false,
      analytics: false,
      terms_and_conditions: false,
    },
    status: "ACTIVE",
  });

  const handleFormData = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePermissionChange = (event) => {
    const { name, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      permission_details: { ...prev.permission_details, [name]: checked },
    }));
  };

  const handleAccessLevelChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permission_details: { ...prev.permission_details, access_level: value || "WRITE" },
    }));
  };

  const handleSubmitUser = () => {
    setShowLoader(true);
    dispatch(registerManagers({ ...formData })).then((res) => {
      if (res?.error && Object.keys(res?.error)?.length > 0) {
        showToast(res?.error?.message, "error");
        setShowLoader(false);
        return;
      }
      setShowLoader(false);
      if (dialogMode && onSuccess) onSuccess();
      else navigate("/dashboard/user-management");
    });
  };

  const submitDisabled =
    !formData.first_name || !formData.last_name || !formData.role || !formData.email || showLoader;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: dialogMode ? "auto" : "100%",
        padding: dialogMode ? 0 : "16px 0 48px 0",
      }}
    >
      <div
        style={{
          padding: dialogMode ? 0 : 24,
          backgroundColor: dialogMode ? "transparent" : "#101010",
          borderRadius: dialogMode ? 0 : 10,
          border: dialogMode ? "none" : "1px solid #ffffff85",
          marginBottom: dialogMode ? 0 : "3rem",
          width: "100%",
          maxWidth: 450,
          boxSizing: "border-box",
        }}
      >
        {/* Basic Information */}
        <div style={{ marginBottom: 24 }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: 12 }}>Basic Information</h2>
          {[
            { name: "first_name", label: "First Name", type: "text" },
            { name: "last_name", label: "Last Name", type: "text" },
            { name: "discord_id", label: "Discord Username", type: "text" },
            { name: "email", label: "Email", type: "email" },
          ].map(({ name, label, type }) => (
            <div key={name} style={{ marginTop: 10 }}>
              <Label style={{ color: "white", letterSpacing: "0.8px", fontFamily: "Inter" }}>{label}</Label>
              <Input
                type={type}
                name={name}
                value={formData[name]}
                placeholder={label}
                onChange={handleFormData}
                style={{ marginTop: 4 }}
              />
            </div>
          ))}
        </div>

        {/* Permissions */}
        <div style={{ marginBottom: 24 }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: 12 }}>Permissions</h2>
          <div style={{ marginBottom: 12 }}>
            <Label style={{ color: "white", letterSpacing: "0.8px", fontFamily: "Inter", display: "block", marginBottom: 6 }}>
              Access Level
            </Label>
            <div style={{ display: "flex", gap: 16 }}>
              {["READ", "WRITE"].map((level) => (
                <label key={level} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 14 }}>
                  <input
                    type="radio"
                    name="access_level"
                    value={level}
                    checked={formData.permission_details.access_level === level}
                    onChange={() => handleAccessLevelChange(level)}
                    style={{ accentColor: "#00ADB5" }}
                  />
                  {level.charAt(0) + level.slice(1).toLowerCase()}
                </label>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {PERMISSIONS.map(({ name, label }) => (
              <label key={name} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14 }}>
                <input
                  type="checkbox"
                  name={name}
                  checked={formData.permission_details[name]}
                  onChange={handlePermissionChange}
                  style={{ accentColor: "#00ADB5" }}
                />
                {label}
              </label>
            ))}
          </div>
        </div>

        <Button onClick={handleSubmitUser} disabled={submitDisabled} style={{ width: "100%" }}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default UserRegisterationForm;
